"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _airbnbPropTypes = require("airbnb-prop-types");

var _styler = _interopRequireDefault(require("../Styler/styler"));

var _unique = _interopRequireDefault(require("../helpers/unique.id"));

var _accordionItem = require("./accordionItem");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Accordion = function Accordion(_ref) {
  var children = _ref.children,
      id = _ref.id,
      background = _ref.background,
      transparent = _ref.transparent,
      borderless = _ref.borderless,
      borderBottom = _ref.borderBottom,
      inlineArrow = _ref.inlineArrow,
      leftArrow = _ref.leftArrow,
      onChange = _ref.onChange;
  var accordionId = id || (0, _unique.default)();
  var accordionStyles = ['co-accordion', {
    'co-accordion--background': background,
    'co-accordion--inline-arrow': inlineArrow,
    'co-accordion--left-arrow': leftArrow
  }];
  var allowedModifiers = {
    borderless: borderless,
    borderBottom: borderBottom,
    transparent: transparent
  };
  return _react.default.createElement(_styler.default, {
    classNames: accordionStyles,
    modifiers: allowedModifiers
  }, function (styles) {
    return _react.default.createElement("ul", {
      className: styles,
      id: accordionId
    }, _react.default.Children.map(children, function (child, index) {
      var itemId = child.props.id || "".concat(accordionId, "-").concat(index);
      return _react.default.cloneElement(child, {
        id: itemId,
        onClick: onChange
      });
    }));
  });
};

var exclusiveArrowProps = (0, _airbnbPropTypes.mutuallyExclusiveTrueProps)('leftArrow', 'inlineArrow');
var exclusiveBackgroundProps = (0, _airbnbPropTypes.mutuallyExclusiveTrueProps)('background', 'transparent');
var exclusiveBorderProps = (0, _airbnbPropTypes.mutuallyExclusiveTrueProps)('borderless', 'borderBottom');
Accordion.propTypes = {
  id: _propTypes.string,

  /** {---} Sequence of: @@<Accordion.Item>@@ (required, min: 1) */
  children: _propTypes.any.isRequired,
  onChange: _propTypes.func,

  /** {bool} Mutually exclusive props: @@background@@ @@transparent@@ */
  background: exclusiveBackgroundProps,

  /** {bool} Mutually exclusive props: @@background@@ @@transparent@@ */
  transparent: exclusiveBackgroundProps,

  /** {bool} Mutually exclusive props: @@leftArrow@@ @@inlineArrow@@ */
  leftArrow: exclusiveArrowProps,

  /** {bool} Mutually exclusive props: @@leftArrow@@ @@inlineArrow@@ */
  inlineArrow: exclusiveArrowProps,

  /** {bool} Mutually exclusive props: @@borderless@@ @@borderBottom@@ */
  borderless: exclusiveBorderProps,

  /** {bool} Mutually exclusive props: @@borderless@@ @@borderBottom@@ */
  borderBottom: exclusiveBorderProps
};
Accordion.Item = _accordionItem.AccordionItem;
var _default = Accordion;
exports.default = _default;
Accordion.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Accordion",
  "props": {
    "id": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "any"
      },
      "required": true,
      "description": "{---} Sequence of: @@<Accordion.Item>@@ (required, min: 1)"
    },
    "onChange": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "background": {
      "type": {
        "name": "custom",
        "raw": "exclusiveBackgroundProps"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@background@@ @@transparent@@"
    },
    "transparent": {
      "type": {
        "name": "custom",
        "raw": "exclusiveBackgroundProps"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@background@@ @@transparent@@"
    },
    "leftArrow": {
      "type": {
        "name": "custom",
        "raw": "exclusiveArrowProps"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@leftArrow@@ @@inlineArrow@@"
    },
    "inlineArrow": {
      "type": {
        "name": "custom",
        "raw": "exclusiveArrowProps"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@leftArrow@@ @@inlineArrow@@"
    },
    "borderless": {
      "type": {
        "name": "custom",
        "raw": "exclusiveBorderProps"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@borderless@@ @@borderBottom@@"
    },
    "borderBottom": {
      "type": {
        "name": "custom",
        "raw": "exclusiveBorderProps"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@borderless@@ @@borderBottom@@"
    }
  }
};